export default {"src":"/_next/static/media/welcome_avatar_cat.ae84bc98.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};